// extracted by mini-css-extract-plugin
export default {"RubiedText":"rubiedText_RubiedText__uWzAX"};